import {
    createFeatureSelector,
    DefaultProjectorFn,
    MemoizedSelector,
} from '@ngrx/store';
import {
    watchlistPageFeatureKey,
    WatchlistPageState,
} from './watchlist-page-state.reducer';

/**
 * Selector to extract the watchlist feature state from the app state.
 */
export const selectWatchlistPageState: MemoizedSelector<
    object,
    WatchlistPageState,
    DefaultProjectorFn<WatchlistPageState>
> = createFeatureSelector<WatchlistPageState>(watchlistPageFeatureKey);
